import React from 'react';
import axios from 'axios';
import {
    Link
  } from 'react-router-dom';
var moment = require('moment');
//var moment = require('moment');

class InboxPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = { 
            step: "login", 
            message : "", 
            data : [
                {id:	1, title : "Web App", type	: 0, description : "Web App version 1.1.2 is available now", link:"https://thahtaylay.com",
                    created_at : "2019-05-21 08:14:30" },
            ]
        };
        
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    hisUrl(url) {
        if(localStorage.getItem("route")) {
          let menu = JSON.parse(localStorage.getItem("route"));
          //console.log(menu.length+"-------------")
          if(menu.length === "0") {
            let data = ["/"];
            localStorage.setItem("route", JSON.stringify(data) );
          } 
           if(menu.length > 0) {
              //console.log(menu[menu.length - 1] + "-" + url )
                if(menu[menu.length - 2] === url ){
                    //console.log("first");
                    menu.pop();
                    //window.BPdata.route = JSON.stringify(menu);
                    localStorage.setItem("route", JSON.stringify(menu) );
                    //localStorage.setItem("route", JSON.stringify(menu) );
                }  
                else if(menu[menu.length-1] !== url ){
                    menu.push(url)
                    //window.BPdata.route = JSON.stringify(menu);
                    localStorage.setItem("route", JSON.stringify(menu) );
                }
                window.BPdata.preurl =  menu[menu.length-2];
            }
        }
      }

    getAnnouncementsApi() {
        var self = this;
        let time = localStorage.getItem(window.BPdata.time);
        let dataurl = window.BPdata.apiUrl+'/user/inbox?time='+time;
        let data = this.state.data;
        axios({
            method: 'get',
            url: dataurl,
            data: data,
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
        })
        .then(function (response) {
            if(response.data.data) {
                self.setState({  
                    data : response.data.data, 
                });

                localStorage.setItem("noti", JSON.stringify(response.data.data) )
                //self.setState({  message : "Successfully updated" });
                //console.log(response.data.data)
            } else {
                self.setState({  message : "Something was wrong" });
            }
            //console.log(response.data.success);
        })
        .catch(function (error) {
            //console.log(error);
        });
    }

    
    
    handleInputChange(event) {
        const target = event.target;
        let value = target.type === 'radio' ? target.checked : target.value;
        let rev_value;
        if(value) {
            value     = 1;
            rev_value = 0;
        } else {
            value     = 0;
            rev_value = 1;
        }
        const name = target.name;
        let str = this.state.contests;
        // console.log(name)
        // console.log(name.split("-").length)

        if(name.split("-").length>0) {
            let word  = name.split("-");
            let first = word[0];
            let id    = word[1];
            console.log(first)
            if(first === "per_result1") {
                str[id].per_result1 = value;
                str[id].per_result2 = rev_value;
            }

            if(first === "per_result2") {
                str[id].per_result2 = value;
                str[id].per_result1 = rev_value;
            }

            if(first === "over") {
                str[id].over = value;
                str[id].under = rev_value;
            }

            if(first === "under") {
                str[id].under = value;
                str[id].over = rev_value;
            }
            
        }
        
        

        this.setState({contests:str});
        //console.log(name)
        // this.setState({
        //   [name]: value
        // });
        console.log(this.state.contests)
    }

    displayBlock( ) {
        let ui = []
        let data = this.state.data
        //console.log(data.length)
        if(data.length  > 0){
            
            // data.forEach(function(each){
            for (let i = 0; i < data.length; i++) { 
                let each = data[i]
                ui.push(<div className="bp-card-link bp-card-static" key={each.id || i}>
                    <div className="bp-card">
                        <div className="bp-card-head">
                            <img src="/img/_verify.png" alt="" className="bp-card-icon" />
                            <span className="bp-card-title">{each.title}</span>
                        </div>
                        <div className="bp-card-desc-full">{each.description}</div>
                        <div className="bp-card-foot">
                            <span className="bp-card-date">{moment(each.created_at).format('DD MMM YYYY, hh:mm A')}</span>
                        </div>
                    </div>
                </div>)
           }

        }

        if(ui.length === 0) {
            ui.push(<div className="bp-empty" key="0"><h2>အချက်အလက်များရှာမတွေ့ပါ။</h2></div>)
        }
        return ui
    }

    componentDidMount() {
        // console.log(mmph.normalizeInput('+၉၅၉၇၈၄၁၂၃၄၅၆')); // returns 09784123456
        // console.log(mmph.normalizeInput('+959784123456')); // returns 09784123456
        // console.log(mmph.getTelecomName('09978412345')); // returns Ooredoo
        // console.log(mmph.getPhoneNetworkType('09978412345')); // returns GSM
        // console.log(mmph.isValidMMPhoneNumber('09978412345')); // returns true if it meets Myanmar Phone
        if(localStorage.getItem(window.BPdata.time)) {
            if(localStorage.getItem(window.BPdata.time) !== "0" ) {
              this.setState({ step: "profile" }); 
            }
            
          } 

        if(localStorage.getItem('noti')) {
            if(JSON.parse(localStorage.getItem("noti")) != null) {
              let noti = JSON.parse(localStorage.getItem("noti"));
              this.setState({data: noti})
              
            }
        } 
        // if(localStorage.getItem('username')) {
        //         this.setState({ 
        //             form: {
        //                 username : localStorage.getItem('username')
        //             } 
        //         }); 
        // } 

        // localStorage.setItem(window.BPdata.time, 0);
        // localStorage.setItem('username', "");
        // else {
        //   localStorage.setItem(window.BPdata.time, 'profile');
        //   this.setState({ step: "home" }); 
        // }
        this.hisUrl('/more/inbox');
        //localStorage.setItem('route', '/more/login');
        //console.log(localStorage.getItem('route'))
        this.getAnnouncementsApi();
    }

    // componentWillUpdate() {
    //     localStorage.setItem('route', '/more/login');
    //     console.log(localStorage.getItem('route'))
    // }

    render() {
        return (
            <div className="page">
                <div className="page-content text-left">
                         
                        <br/>
                        <div className="list-header">
                            <img src="/img/badge.jpg" className="list-img-circle" alt={window.lang.title.inbox} /><span>{window.lang.title.inbox}</span>
                        </div>
                        
                        <br />
                      
                            <ul className="secondsubmenu">
                                <li>
                                    <Link to="/more/inbox" className="btn-success btn color-gold" >
                                        {window.lang.title.inbox}
                                    </Link> 
                                </li>
                                <li>
                                    <Link to="/more/transaction" className="btn-success btn " >
                                        {window.lang.title.payment}
                                    </Link> 
                                </li>
                                <li>
                                    <Link to="/more/order" className="btn-success btn" >
                                        {window.lang.title.order}
                                    </Link> 
                                </li>
                            </ul>
                        <br/>
                        <br/>
                        {this.displayBlock()}
                        <br />


                    <div className="ant-back-footer">
                        <div className="ant-back-top">
                            <div className="ant-back-top-content">
                                <Link to={window.BPdata.preurl} className="color-green" >
                            { (JSON.parse(localStorage.getItem("route")) !== null) 
                            ? ((this.state.url !== "/" || JSON.parse(localStorage.getItem("route"))[JSON.parse(localStorage.getItem("route")).length-1] !== "/") ?  <img src="/img/back-arrow.png" alt="back" />: ""  ) : "" }
                            </Link> 
                            </div>
                        </div>
                    </div>
                   
                </div>
               
            </div>
        );
    }
}

export default InboxPage;